import { axios } from "utils";

import { GLOBAL_USER_URL as endpoint } from "consts";

// ------------------------------------------------------------------

// uploading files for users only

const uploadUserFile = async (data) => axios.post(`${endpoint}/files`, { data });

export const addUserFile = async (data) => {
  const reader = new FileReader();
  const type = data.file.name.split(".").pop().toLowerCase();

  return new Promise((resolve, reject) => {
    reader.onerror = () => {
      reader.abort();
      reject(new DOMException("Problem parsing input file."));
    };

    reader.onload = () => {
      uploadUserFile({
        file: reader.result,
        location: data.location ? data.location : "uploads",
        type,
      }).then((res) => {
        resolve(res);
      });
    };
    reader.readAsDataURL(data.file);
  });
};

// ------------------------------------------------------------------
